import { render } from "./Prompt.vue?vue&type=template&id=4e3e2149"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
script.render = render

export default script